export default __webpack_public_path__ + "static/media/our-features-2.6cd6a4b8.png";